import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
  Paper,
} from "@material-ui/core";
import { green, orange, red } from "@material-ui/core/colors";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Drag from "../Components/draganddrop";
import cross from "../Assets/cross.svg";
import DummyImage from "../Assets/product_img.svg";
import upload from "../Assets/drag.svg";
import ButtonIconComponent from "../Components/ButtonIcons";
import {
  AddSingleDocNestedCollection,
  GetAllData,
  GetAllDataNestedCollections,
  GetSingleData,
  GetSingleData123,
  getItemsCountNestedCollection,
} from "../NetworkCalls/Admin/ServerReq";
import UploadImage from "../Components/uploadimage";
import { toast } from "react-toastify";

const AddMenu = () => {
  const params = useParams();
  const [loader, setLoader] = useState(false);
  const [addMenuLoading, setAddmenuLoading] = useState(false);
  const [mainLoader, setMainLoader] = useState(true);
  const [imgweb, setImgweb] = useState("");
  const [tempimg, setTempimg] = useState("");
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [dataAllMenusCounter, setDataAllMenusCounter] = useState("");
  const [categories, setCategories] = useState([]);
  const [restaurantName, setRestaurantName] = useState("");
  const [Error, setError] = useState("");

  async function handleClick(event) {
    event.preventDefault();
    setOpen(true);
  }

  // console.log(blogdata?.blogimg)
  const { setDragOver, onDragOver, onDragLeave, setFileDropError } = Drag();

  const onDrop = (e) => {
    e.preventDefault();

    setDragOver(false);

    const selectedFile = e?.dataTransfer?.files[0];

    if (selectedFile.type.split("/")[0] !== "image") {
      return setFileDropError("Please provide an image file to upload!");
    }

    setTempimg(selectedFile);
  };

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    const getDataAllMenus = async () => {
      try {
        setLoader(true);
        const response = await getItemsCountNestedCollection(
          params.category,
          params.categoryid,
          "Menu"
        );

        setDataAllMenusCounter(response);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getDataAllMenus();
  }, []);

  useEffect(() => {
    const getAllCategories = async () => {
      try {
        setLoader(true);
        const response = await GetAllData("Categories");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        arr.sort((a, b) => a.name.localeCompare(b.name));

        setCategories(arr);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAllCategories();
  }, []);

  useEffect(() => {
    const getRestaurantName = async () => {
      try {
        setLoader(true);
        const response = await GetSingleData("Restaurants", params?.categoryid);
        setRestaurantName(response?.businessName);
      } catch (err) {
      } finally {
      }
    };

    getRestaurantName();
  }, []);

  const handleAddMenu = async (e) => {
    e.preventDefault();

    
    setError("");

    try {
      setAddmenuLoading(true);
      UploadImage({ img: tempimg }).then(async (res) => {
        setImgweb(res);

        await AddSingleDocNestedCollection(
          params.category,

          params?.categoryid,
          "Menu",
          { ...data, photoLink: res }
        );

        setAddmenuLoading(false);
        setImgweb("");
        setTempimg("");
        toast.success("Menu added !")
        
      });
    } catch (e) {
      setError(e);
      setAddmenuLoading(true);
    } finally {
      setAddmenuLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: "10px", alignItems: "center" }}
        justify="space-between"
        container
        spacing={24}
      >
        <Grid
          item
          lg={8}
          xl={8}
          style={{
            display: "flex",

            alignItems: "center",
            gap: "2rem",
          }}
        >
          <Typography
            gutterBottom
            variant="h3"
            display="inline"
            style={{
              fontWeight: "700",
              letteSpacing: "0.2px",
              fontSize: "25px",
              margin: "0",
            }}
          >
            Add Menu
          </Typography>

          <Box>
            <Typography
              gutterBottom
              variant="h3"
              display="inline"
              style={{
                letteSpacing: "0.2px",
                fontSize: "20px",
                marginRight: "10px",
              }}
            >
              Menu Count :
            </Typography>

            <Typography
              gutterBottom
              variant="h3"
              display="inline"
              style={{
                letteSpacing: "0.2px",
                fontSize: "20px",
              }}
            >
              {dataAllMenusCounter && dataAllMenusCounter}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Paper
        style={{
          boxShadow: "none !important",
          border: "1px solid rgba(76, 78, 100, 0.25)",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        {/* =============== */}

        <Grid
          style={{ marginBottom: "10px", marginTop: "35px" }}
          justify="space-around"
          container
          spacing={2}
        >
          <Grid item xs={12} xl={12} lg={12} md={12}>
            <p style={{ fontSize: "11px", marginBottom: "20px" }}>
              Upload Image*
            </p>

            {/* ======= */}

            {imgweb == "" && tempimg == "" ? (
              <div className="addImage">
                <div className="imagebody">
                  <img
                    src={upload}
                    style={{ marginBottom: "20px" }}
                    alt="logo"
                  />
                  <p>
                    Drag and drop an image, or{" "}
                    <label
                      for="upload-photo"
                      className="upload-label"
                      onDragOver={onDragOver}
                      onDragLeave={onDragLeave}
                      onDrop={onDrop}
                    >
                      Browse{" "}
                    </label>
                    <input
                      type="file"
                      name="WebImage"
                      onChange={(e) => {
                        setTempimg(e.target.files[0]);
                      }}
                      id="upload-photo"
                      style={{ display: "none" }}
                      // required={true}
                    />
                    <br /> 1600x1200 or higher recommended. Max 10MB.
                  </p>
                </div>
              </div>
            ) : (
              <div className="addImage">
                <>
                  <label
                    for="upload-photo"
                    className="upload-label"
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                  >
                    <input
                      type="file"
                      //  accept="image/*"
                      name="WebImage"
                      onChange={(e) => {
                        UploadImage({ img: e.target.files[0] })
                          .then((res) => {
                            console.log("Image uploaded successfully:", res);
                            setImgweb(res);
                          })
                          .catch((error) => {
                            console.error("Error uploading image:", error);
                            // Handle the error, e.g., display an error message
                          });
                        setTempimg(e.target.files[0]);
                      }}
                      id="upload-photo"
                      style={{ display: "none" }}
                    />

                    <img
                      alt="logo"
                      src={cross}
                      style={{
                        width: "35px",
                        top: "-25px",
                        position: "absolute",
                        right: "-25px",
                      }}
                      onClick={() => {
                        tempimg == "" ? setImgweb("") : setTempimg("");
                      }}
                    />
                    {tempimg == "" ? (
                      <img
                        alt="logo"
                        src={DummyImage}
                        style={{ width: "100%", height: "100%" }}
                      />
                    ) : (
                      <img
                        alt="logo"
                        src={URL.createObjectURL(tempimg)}
                        // src={tempimg}
                        style={{ width: "100%", height: "100%" }}
                      />
                    )}

                    {/* ====== */}
                  </label>
                </>
              </div>
            )}

            {/* ======== */}
          </Grid>
        </Grid>

        {/* =============== */}

        <form onSubmit={handleAddMenu}>
          <Grid
            style={{ marginBottom: "10px", marginTop: "35px" }}
            container
            spacing={2}
          >
            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="name"
                label="Enter menu name"
                variant="outlined"
                required
                // value={data?.name}
                // InputLabelProps={{ shrink: true }}
                onChange={handleOnchange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="number"
                name="price"
                label="Enter menu price"
                variant="outlined"
                required
                // value={data?.price}
                // InputLabelProps={{ shrink: true }}
                onChange={handleOnchange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <TextField
                id="outlined-basic"
                type="text"
                name="description"
                label="Enter menu description"
                variant="outlined"
                required
                // value={data?.description}
                // InputLabelProps={{ shrink: true }}
                onChange={handleOnchange}
                fullWidth={true}
              />
            </Grid>

            <Grid item xs={12} xl={6} lg={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select menu category
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Enter menu category"
                  name="category"
                  // value={selectedCategory}
                  onChange={handleOnchange}
                >
                  {categories &&
                    categories.map((item, index) => (
                      <MenuItem key={index} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box>
            <ButtonIconComponent
              loader={addMenuLoading}
              name="Save"
              // onClick={handleAddMenu}
              imageBool={false}
              type={"submit"}
            />
          </Box>
        </form>
      </Paper>
    </React.Fragment>
  );
};

export default AddMenu;
